import React, { useState } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  InputAdornment,
    FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik } from "formik";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

//Services
import CorporateApi from "Services/CorporateGroup";

//DropZone
// import DropZone from "./DropZone";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PassengerCreate = (props) => {
  const { openDialog, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

    const  corporateId = useSelector(
      (state) => state?.ProfileSettingsReducer?.profiledetails?._id
    );
  //pagination
  const handleAddGroup = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    let validatationPass = true;

    const data = {
      corporateGroupName: formValues?.corporateGroupName,
      corporateId:corporateId,
      autopay:formValues?.autopay,
    };
    
   console.log('data--->',data);
   // return false;
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.success === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Group Created Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        handleClose();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while create Group",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    if (validatationPass) {
      CorporateApi.addCorporategroup({ ...data }).then(onSuccess, onFailure);
    }
  };

  // Formik
  const formik = useFormik({
    initialValues: {
      corporateGroupName: "",
      autopay:true
    },
    validationSchema: yup.object({
      corporateGroupName: yup.string().required("Group Name is required").nullable()
    }),
    enableReinitialize: true,
    onSubmit: handleAddGroup,
  });

  //Tabs

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Add Group
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>

          <Grid container>

          <Grid container>
            <section className={classes.container}>
              <Grid item xs={12} className={classes.detailsContainer}>
                <Grid container className={classes.containerWrapper}>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          id="corporateGroupName"
                          label="Group Name"
                          value={formik?.values?.corporateGroupName}
                          defaultValue={formik?.values?.corporateGroupName}
                          onChange={formik.handleChange}
                          error={
                            formik?.errors?.corporateGroupName &&
                            formik?.touched?.corporateGroupName
                          }
                          helperText={
                            formik?.errors?.corporateGroupName &&
                            formik?.touched?.corporateGroupName &&
                            formik?.errors?.corporateGroupName
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        ></TextField>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
<FormControl component="fieldset" className={classes.textFieldWrapper}>
  <FormLabel component="legend">Payment Mode</FormLabel>
  <RadioGroup
    aria-label="paymentMode"
    name="autopay"
    value={formik.values.autopay ? "true" : "false"}
    onChange={formik.handleChange}
  >
    <FormControlLabel
      value="true"
      control={<Radio checked disabled />}
      label={
        <>
          <Typography variant="body2" style={{ fontWeight: "bold" }}>
            Auto-Paid By Company
          </Typography>
          <Typography variant="caption">
            Ride bills are automatically deducted from your corporate account
          </Typography>
        </>
      }
    />
  </RadioGroup>
</FormControl>                        
                      </Grid>

</Grid>
</Grid>
</Grid>
</Grid>

       </section>
                </Grid>

                <Grid container>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={classes.sbtBtnWrapper}
                  >
                    <Button variant="contained" onClick={formik?.handleSubmit}>
                      Add Group
                    </Button>
                  </Grid>
                </Grid>

              </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>Close</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PassengerCreate;
